import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
  standalone: false
})
export class FilterComponent implements OnInit {
  @Input() adminMode: boolean = false; // 👈 nuevo flag

  public fixed: boolean = false; 
  public everFixed: boolean = false;
  showFirst = true;
  tOp: string;
  filter: any = [];
  filterLS: any = {};
  filterSelected: any = [];
  barriosList: any[] ;
  filterPosition: number;

  lisDOrm: any[] = [
    { code: 'ALL', descripcion: 'Dormitorios' },
    { code: '1', descripcion: '1 dorm.' },
    { code: '2', descripcion: '2 dorm.' },
    { code: '3', descripcion: '3 dorm.' },
    { code: '*', descripcion: '4 o +' }
  ];

  @Output() search = new EventEmitter<[any]>();

  constructor(
    private filtersServ: FiltersService,
    private activateRoute: ActivatedRoute
  ) {
    this.getLocalidades();
    this.getBarrios();
    this.getTipoPro();
    this.getTipoOpe();
    this.getDorm();
    this.tOp = activateRoute.snapshot.url[0].path;

    if (this.tOp === 'venta' || this.tOp === 'alquiler') {
      this.obtProp(JSON.parse(localStorage.getItem(this.getStorageKey())));
      this.fixed = true;
    } else if (this.tOp === 'ALL') {
      this.fixed = true;
    } else {
      this.obtProp([]);
    }
  }

ngOnInit(): void {
  const raw = this.adminMode
    ? sessionStorage.getItem(this.getStorageKey())
    : localStorage.getItem(this.getStorageKey());

  this.filterLS = raw ? JSON.parse(raw) : {};

  // ✅ Defaults para evitar espacios en blanco
  if (!this.filterLS.tipoOpe || this.filterLS.tipoOpe === '') {
    this.filterLS.tipoOpe = this.adminMode ? 'ALL' : 'VENTA';
  }
  if (!this.filterLS.tipoPr || this.filterLS.tipoPr === '') {
    this.filterLS.tipoPr = 'ALL';
  }
  if (!this.filterLS.localidad || this.filterLS.localidad === '') {
    this.filterLS.localidad = 'ALL';
  }
  if (!this.filterLS.barrio || this.filterLS.barrio === '') {
    this.filterLS.barrio = 'ALL';
  }
  if (!this.filterLS.dormitorio || this.filterLS.dormitorio === '') {
    this.filterLS.dormitorio = 'ALL';
  }
  if (this.filterLS.cochera === undefined) {
    this.filterLS.cochera = false;
  }
  if (this.filterLS.patio === undefined) {
    this.filterLS.patio = false;
  }
  if (this.filterLS.apCredito === undefined) {
    this.filterLS.apCredito = false;
  }
  if (this.adminMode && !this.filterLS.direccion) {
    this.filterLS.direccion = '';
  }
}


  ngAfterViewChecked() {
    const h1 = document.querySelector('app-filter');
    if (h1) {
      this.filterPosition = h1.getBoundingClientRect().top;
    }
  }

  /** 🔹 Clave de storage separada */
  private getStorageKey(): string {
    return this.adminMode ? 'filterAdmin' : 'filter';
  }

  /** 🔹 Guardar en localStorage */
  saveToStorage() {
      if (this.adminMode) {
        sessionStorage.setItem(this.getStorageKey(), JSON.stringify(this.filterLS));
      } else {
        localStorage.setItem(this.getStorageKey(), JSON.stringify(this.filterLS));
      }
  }
  


  obtProp(fil: any) {
    this.search.emit(fil);
  }

  setOperacion(tipo: string) {
    this.filterLS.tipoOpe = tipo;
    this.saveToStorage();
  }

  ObtenerPropiedades(form: NgForm) {
    let fil: any = {
      tipoPr: this.filterLS.tipoPr || 'ALL',
      tipoOpe: this.adminMode
      ? (this.filterLS.tipoOpe || 'ALL')
      : (this.tOp === 'inicio' ? (this.filterLS.tipoOpe || 'ALL') : this.tOp),

      localidad: this.filterLS.localidad || 'ALL',
      barrio: this.filterLS.barrio || 'ALL',
      dormitorio: this.filterLS.dormitorio || 'ALL',
      cochera: this.filterLS.cochera || false,
      patio: this.filterLS.patio || false,
      apCredito: this.filterLS.apCredito || false,
      direccion: this.adminMode ? (this.filterLS.direccion || '') : undefined // 👈 extra en admin
    };

    this.filterLS = fil;
    this.saveToStorage();
    this.obtProp(fil);
  }

  // ========= servicios de datos =========
  getLocalidades() {
    this.filtersServ.getLocalidad().subscribe((data: any[]) => {
      this.filter.localidades = data;
      this.filter.localidades.unshift({ descripcion: 'Ciudad', code: 'ALL', id: -1 });
    }, (errorService) => console.log(errorService));
  }

  getBarrios() {
    this.filtersServ.getBarrio().subscribe((data: any[]) => {
      this.barriosList = data;
      this.filter.barrios = [];
      this.filter.barrios.unshift({ descripcion: 'Barrio', code: 'ALL' });
    }, (errorService) => console.log(errorService));
  }

  getTipoPro() {
    this.filtersServ.getTipoPro().subscribe((data: any[]) => {
      this.filter.tiposPro = data;
      this.filter.tiposPro.unshift({ descripcion: 'Tipo propiedad', code: 'ALL' });
    }, (errorService) => console.log(errorService));
  }

  getTipoOpe() {
    this.filtersServ.getTipoOpe().subscribe((data: any[]) => {
      this.filter.tiposOpe = data;
      this.filter.tiposOpe.unshift({ descripcion: 'Tipo operación', code: 'ALL' });
    }, (errorService) => console.log(errorService));
  }

  getDorm() {
    this.filter.dormitorios = this.lisDOrm;
  }

  loadBarrios(ev: any) {
    this.filter.barrios = [];
    this.filter.barrios.unshift({ descripcion: 'Barrio', code: 'ALL', id: '', localidadId: '' });
    this.barriosList.forEach(element => {
      if (element.codeLocalidad === ev) {
        this.filter.barrios.push(element);
      }
    });
  }

  loadDormitorios(ev: any) {
    if (ev == 'MONO') {
      this.filter.dormitorios = [];
      this.filter.dormitorios.unshift({ descripcion: 'Dormitorios', code: 'ALL', id: '', localidadId: '' });
    } else {
      this.filter.dormitorios = this.lisDOrm;
    }
  }
}
